<template>
  <div class="billDetail">
    <div class="sale-halt">该商品已停售</div>
    <div class="sale-content"><span>货品名称：</span><span>包菜</span></div>
    <div class="sale-content"><span>包装形式：</span><span>定装</span></div>
    <div class="sale-content"><span>重量单位：</span><span>公斤</span></div>
    <div class="sale-content">销售单价：2.1元/公斤</div>
    <div class="sale-text">规格
      <!-- <em>（必填）</em> -->
      </div>
    <div class="sale-input"><input type="text" placeholder="请输入规格"><span>公斤/件</span></div>
    <div class="sale-text">销售单价</div>
    <div class="sale-input"><input type="number" placeholder="请输入销售单价"><span>元/公斤</span></div>
    <div class="sale-explain">注：此货品已售卖，不可修改名称或删除</div>
    <!-- <div class="sale-on">开 售</div> -->
    <div class="sale-off"><span>停售货品</span><span>保存</span></div>
  </div>
</template>

<script>
export default {
  name: "billDetail",
  data() {
    return {
      
    };
  },
  created() {
    
  },
  mounted() {},
  methods: {
  }
};
</script>

<style lang="less" scoped>
.billDetail {
  .sale-halt{
    width: 100%;
    line-height: 0.48rem;
    background:rgba(247,105,0,0.2);
    color: #F76900;
    padding: 0 0.2rem;
    margin-bottom: 0.15rem;
  }
  .sale-content{
    line-height: 0.61rem;
    padding: 0 0.2rem;
    font-size: 0.32rem;
    >span:first-child{
      color: #666666;
    }
    >span:last-child{
      color: #333333;
    }
  }
  .sale-text{
    line-height: 0.61rem;
    padding: 0 0.2rem;
    font-size: 0.32rem;
    em{
      color: #FF0000;
    }
  }
  .sale-input{
    width: 100%;
    line-height: 0.72rem;
    background-color: #fff;
    color: #999999;
    input{
      width: 80%;
      padding: 0 0.2rem;
    }
  }
  .sale-explain{
    padding-right: 0.2rem;
    text-align: right;
    margin-top: 0.2rem;
    color: #999999;
    font-size: 0.24rem;
  }
  .sale-on{
    position: fixed;
    bottom: 0;
    color: #fff;
    width: 100%;
    line-height: 1.08rem;
    background-color: #31B158;
    text-align: center;
    font-size: 0.36rem;
  }
  .sale-off{
    position: fixed;
    bottom: 0;
    color: #fff;
    height: 0.72rem;
    text-align: center;
    font-size: 0.36rem;
    padding: 0.18rem 0.2rem;
    background-color: #fff;
    >span{
      display: inline-block;
      width: 3.55rem;
      line-height: 0.72rem;
    }
    >span:first-child{
      background-color: #FFBA00;
      border-radius: 0.36rem 0 0 0.36rem;
    }
    >span:last-child{
      background-color: #31B158;
      border-radius: 0 0.36rem 0.36rem 0;
    }
  }
}
</style>